import React, {useCallback, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import PageTitle from '../shared/PageTitle';
import {Box} from '@mui/material';
import {Profile} from '../../interfaces';
import ProfileDeleteRequestsTable from './ProfileDeleteRequestsTable';
import {deleteProfile, getProfiles, restoreProfile} from '../../api/adminAPI';

interface Props {}

const AdminProfileDeleteRequests: React.FC<Props> = () => {
  const {t} = useTranslation();
  const [profiles, setProfiles] = React.useState<Profile[]>([]);

  const fetchData = useCallback(async () => {
    const profiles = await getProfiles();
    setProfiles(profiles);
  }, []);

  const onDeleteProfile = useCallback(
    async (id: number) => {
      const confirmed = window.confirm(
        'Are you sure you wish to delete this profile?',
      );
      if (confirmed) {
        const res = await deleteProfile({id});
        if (res?.success) {
          fetchData();
        }
      }
    },
    [fetchData],
  );

  const onRestoreProfile = useCallback(
    async (id: number) => {
      const confirmed = window.confirm(
        'Are you sure you wish to restore this profile?',
      );
      if (confirmed) {
        const res = await restoreProfile(id);
        if (res?.success) {
          fetchData();
        }
      }
    },
    [fetchData],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <Helmet>
        <title>{t('pages.profileDeleteRequests')}</title>
      </Helmet>
      <Box>
        <PageTitle>{t('pages.profileDeleteRequests')}</PageTitle>
        <ProfileDeleteRequestsTable
          profiles={profiles ?? []}
          onDeleteProfile={onDeleteProfile}
          onRestoreProfile={onRestoreProfile}
        />
      </Box>
    </>
  );
};

export default React.memo(AdminProfileDeleteRequests);
